import { useFetchAffiliations } from '@sekoia/shared/hooks/requests/atlas/useFetchAffiliations';
import { useMemo } from 'react';
import { Toggle } from '@sekoia/shared/helpers/toggles/Toggle';
import { useTogglesContext } from '@sekoia/shared/contexts/Toggles/TogglesContext';

/**
 * Checks if Toggle(s) are enabled for any affiliated organisations or enabled for customer
 */

function useTogglesEnabledForAnyAffiliatedOrganisations(...togglesToCheck: string[]): {
  results: boolean[];
  isLoading: boolean;
} {
  const toggles = useTogglesContext();
  const { data: affiliations, error: affiliationsError, isLoading } = useFetchAffiliations();

  const togglesResult: boolean[] = useMemo(() => {
    const organisationIds = affiliations?.map((affiliation) => affiliation.organisationId) ?? [];
    const distinctOrganisationIds = [...new Set(organisationIds)];

    const nextResult: boolean[] = [];
    togglesToCheck.forEach((toggle) => {
      nextResult.push(
        toggles.some(
          (t: Toggle) => t.name === toggle && t.IsEnabledForAnyAffiliatedOrganisation(distinctOrganisationIds),
        ),
      );
    });
    return nextResult;
  }, [affiliations, toggles, togglesToCheck]);

  if (affiliationsError) {
    throw Error(`Failed to fetch my affiliations while checking toggles`);
  }

  return {
    results: togglesResult,
    isLoading,
  };
}

export default useTogglesEnabledForAnyAffiliatedOrganisations;
